<template>
  <span id="footer" />
</template>

<script>
export default {};
</script>

<style scoped></style>
